import { inject, Injectable } from '@angular/core';
import {
  ApiClientService,
  ITenantOrganisation,
  IUpdateTenantOrganisationPayload,
  TENANT_API
} from '@pharvio/core/shared';
import { Observable } from 'rxjs';
import { TenantOrganisationDataService } from './repositories/tenant-organisation-data.service';

@Injectable()
export class HttpTenantOrganisationDataService extends TenantOrganisationDataService {
  private readonly api = inject(ApiClientService);

  getTenantOrganisation(): Observable<ITenantOrganisation> {
    return this.api.get<ITenantOrganisation>(TENANT_API.TENANT_ORGANISATION.GET);
  }

  updateTenantOrganisation(
    payload: IUpdateTenantOrganisationPayload
  ): Observable<ITenantOrganisation> {
    return this.api.patch<ITenantOrganisation>(
      TENANT_API.TENANT_ORGANISATION.UPDATE,
      payload
    );
  }
}
